import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["afterIcon", "allowIconLeading", "beforeIcon", "children", "color", "disabled", "fontSize", "fontWeight", "inline", "loading", "onClick", "spacingSize", "textDecoration"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { clsx } from 'clsx';
import { useForkRef } from '@cian/react-utils';
import { useKeyboardEventHandler } from './internal/hooks';
import * as styles from './styles.module.css';
import { Spinner } from '../../../loader';
import { getTypographyComponent, InlineIconText, useLeadingIcon } from '../../internal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент кнопки-ссылки для действий внутри одной страницы, не должен затрагивать url.
 */
var ActionLinkComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var afterIcon = _ref.afterIcon,
    _ref$allowIconLeading = _ref.allowIconLeading,
    allowIconLeading = _ref$allowIconLeading === void 0 ? false : _ref$allowIconLeading,
    beforeIcon = _ref.beforeIcon,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'default' : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'M' : _ref$fontSize,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'normal' : _ref$fontWeight,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    onClick = _ref.onClick,
    _ref$spacingSize = _ref.spacingSize,
    spacingSize = _ref$spacingSize === void 0 ? 'XS' : _ref$spacingSize,
    _ref$textDecoration = _ref.textDecoration,
    textDecoration = _ref$textDecoration === void 0 ? 'none' : _ref$textDecoration,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = clsx(styles['action-link'], styles["spacing-size-".concat(spacingSize)], styles["font-size-".concat(fontSize)], styles["text-decoration-".concat(textDecoration)], styles[color], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['loading'], loading), styles['disabled'], disabled), styles['no-content'], !children), styles['inline'], inline));
  var _useLeadingIcon = useLeadingIcon({
      allowIconLeading: allowIconLeading,
      beforeIcon: beforeIcon,
      inline: inline
    }),
    linkRef = _useLeadingIcon.linkRef,
    beforeIconRef = _useLeadingIcon.beforeIconRef;
  var handleRef = useForkRef(ref, linkRef);
  var TypographyComponent = getTypographyComponent(fontSize, fontWeight);
  var beforeIconElement = beforeIcon && /*#__PURE__*/_jsx("span", {
    ref: beforeIconRef,
    className: styles['before-icon'],
    children: beforeIcon
  });
  var afterIconElement = afterIcon && /*#__PURE__*/_jsx("span", {
    className: styles['after-icon'],
    children: afterIcon
  });
  var content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading && /*#__PURE__*/_jsx("div", {
      className: styles['spinner'],
      children: /*#__PURE__*/_jsx(Spinner, {
        size: 16,
        color: "current_color"
      })
    }), children ? /*#__PURE__*/_jsx(TypographyComponent, {
      as: "span",
      color: "current_color",
      display: "inline",
      children: /*#__PURE__*/_jsx(InlineIconText, {
        beforeIcon: beforeIconElement,
        afterIcon: afterIconElement,
        textClassName: styles['text'],
        children: children
      })
    }) : beforeIcon]
  });
  var handleSpanKeyDown = useKeyboardEventHandler(onClick);
  var baseProps = _objectSpread({
    ref: handleRef,
    className: className,
    onClick: onClick
  }, rest);
  if (inline) {
    return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
      role: "button",
      tabIndex: 0,
      onKeyDown: handleSpanKeyDown
    }, baseProps), {}, {
      children: content
    }));
  }
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, baseProps), {}, {
    children: content
  }));
});
ActionLinkComponent.displayName = 'ActionLink';
export var ActionLink = /*#__PURE__*/React.memo(ActionLinkComponent);